import styled from 'styled-components';

export const ButtonWrapper = styled.a`
  &:link {
    color: ${props => props.theme.colors.lightBlue2};
    text-decoration: none;
  }
  &:visited {
    color: ${props => props.theme.colors.lightBlue2};
    text-decoration: none;
  }
  font-size: 12px;
  ${props => props.theme.mediaQueries.tablet_big_down_world_cup}{
    font-size: 14px;
  };
  visibility: ${props => (props.visibility ? props.visibility : 'visibile')};
`;

export const ButtonLabel = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${props => props.theme.fontSets.BreraRegular};
  text-transform: uppercase;
  margin-left: ${props => (props.isBottomLink ? '0px' : '40px')};
`;



// WEBPACK FOOTER //
// ./src/components/shared/CorriereLink/styles.js